var _circle, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoPlayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 46,
    r: 46,
    fill: "#1C1C1C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_736_13239",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 21,
    width: 50,
    height: 50
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 21,
    width: 50,
    height: 50,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_736_13239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.7891 55.3753L55.3724 46.0003L40.7891 36.6253V55.3753ZM45.9974 66.8337C43.1155 66.8337 40.4071 66.2868 37.8724 65.193C35.3377 64.0993 33.1328 62.6149 31.2578 60.7399C29.3828 58.8649 27.8984 56.6601 26.8047 54.1253C25.7109 51.5906 25.1641 48.8823 25.1641 46.0003C25.1641 43.1184 25.7109 40.41 26.8047 37.8753C27.8984 35.3406 29.3828 33.1357 31.2578 31.2607C33.1328 29.3857 35.3377 27.9014 37.8724 26.8076C40.4071 25.7139 43.1155 25.167 45.9974 25.167C48.8793 25.167 51.5877 25.7139 54.1224 26.8076C56.6571 27.9014 58.862 29.3857 60.737 31.2607C62.612 33.1357 64.0964 35.3406 65.1901 37.8753C66.2839 40.41 66.8307 43.1184 66.8307 46.0003C66.8307 48.8823 66.2839 51.5906 65.1901 54.1253C64.0964 56.6601 62.612 58.8649 60.737 60.7399C58.862 62.6149 56.6571 64.0993 54.1224 65.193C51.5877 66.2868 48.8793 66.8337 45.9974 66.8337Z",
    fill: "#FFDD00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlayer);
export default __webpack_public_path__ + "static/media/video-player.d9e2fd1a9eda73f4e4ac31278717ed49.svg";
export { ForwardRef as ReactComponent };